import React, { useEffect, Fragment } from 'react';
import { BaseTemplate, PageHead } from '@myob/myob-widgets';
import Tile from 'modules/BillingAndPayments/components/Tile';
import paymentDetails from 'assets/images/paymentDetails.svg';
import bills from 'assets/images/bills.svg';
import { TilesWrapper } from 'modules/BillingAndPayments/styles';
import { ERoutePath } from 'router';
import { Operation } from 'stores/type';
import { useOperation } from 'hooks/useOperation';
import { useHistory } from 'react-router-dom';
import { EPage } from 'pages/ErrorPages/Unauthorized/pageContent';
import * as telemetry from 'telemetry';
import { ETelemetryActionsAndLabels, ETelemetryNames } from 'telemetry/type';
import { Permission } from 'helpers/paymentProfile';
import { useSelector } from 'react-redux';
import { RootState } from 'stores';
import { ErrorResponse } from 'helpers/type';
import { LocationStateInUnauthorizedPage } from 'pages/ErrorPages/Unauthorized/Unauthorized';
import NavigationBar from 'components/NavigationBar';

const generateLink = (route: ERoutePath) => {
    return `#${route}`;
};

const BillingAndPayments: React.FC = () => {
    const canViewInvoice = useOperation(Operation.VIEW_INVOICE);
    const error = useSelector<RootState, ErrorResponse | null>(state => state.userInfo.error);
    const history = useHistory<LocationStateInUnauthorizedPage>();

    telemetry.track(ETelemetryNames.BillingAndPaymentsDashboard, {
        action: ETelemetryActionsAndLabels.View,
        label: ETelemetryActionsAndLabels.View,
        viewData: { permission: canViewInvoice ? Permission.Granted : Permission.Denied, reason: error },
    });
    useEffect(() => {
        if (!canViewInvoice) {
            history.push({
                pathname: ERoutePath.Unauthorized,
                state: {
                    pageName: EPage.BillingAndPayments,
                },
            });
        }
    }, [canViewInvoice, history]);

    return (
        <Fragment>
            <NavigationBar />
            <BaseTemplate>
                <PageHead title="Billing and payments" />
                <p>Manage payment details and bills for your subscriptions and purchases</p>
                <TilesWrapper>
                    <Tile
                        title="Payment details"
                        description="View or update your current payment methods for your account"
                        image={paymentDetails}
                        linkText="See payment details"
                        link={generateLink(ERoutePath.PaymentProfile)}
                        buttonName="PaymentDetails"
                    />
                    <Tile
                        title="My bills"
                        description="View all bills for your subscriptions and purchases"
                        image={bills}
                        linkText="View my bills"
                        link={generateLink(ERoutePath.MyBills)}
                        buttonName="MyBills"
                    />
                </TilesWrapper>
            </BaseTemplate>
        </Fragment>
    );
};

export default BillingAndPayments;
